import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography

export const DOCUMENT_TYPE_OPTIONS = [
  { value: 'CC', label: <>Cédula de ciudadanía <Text type='secondary'>(CC)</Text></> },
  { value: 'NIT', label: <>NIT</> },
  { value: 'TI', label: <>Tarjeta de identidad <Text type='secondary'>(TI)</Text></> },
  { value: 'CE', label: <>Cédula de extranjería <Text type='secondary'>(CE)</Text></> },
  { value: 'PA', label: <>Pasaporte <Text type='secondary'>(PA)</Text></> },
];